import { EXPENSE_POLICY_CONST } from '../actionConstants';
import { setDataInGroup, formatGroupData, formatPolicyData } from '../../expense/components/Policy/utils';

const INITIAL_STATE = {
    groups: null,
    editGroupsData: null,
    managerList: [],
    employeeList: [],
    categoryList: [],
    tabLoader: false,
    policyLoader: false,
    policySaveLoader: false,
    expensePolicyData:{},
    selectedGroupIndex: -1
}

export default (state=INITIAL_STATE, action) => {
    if (!action) {
        return state;
    }

    const { type, payload = {} } = action;

    switch(type) {
        case EXPENSE_POLICY_CONST.APPROVAL_INPUTS: {
            const { groupId, key } = payload;
            const { editGroupsData = {}} = state;
            const groupsClone = {...editGroupsData};
            const singleGroup = groupsClone[groupId] || {};
            setDataInGroup(singleGroup, payload);
            groupsClone[groupId] = singleGroup;
            return {
                ...state,
                editGroupsData: groupsClone,
            }
        }
        case EXPENSE_POLICY_CONST.MANAGER_LIST: {
            return {
                ...state,
                managerList: payload
            }
        }
        case EXPENSE_POLICY_CONST.EMPLOYEE_LIST: {
            return {
                ...state,
                employeeList: payload
            }
        }
        case EXPENSE_POLICY_CONST.CAT_LIST: {
            return {
                ...state,
                categoryList: payload,
            }
        }
        case EXPENSE_POLICY_CONST.POLICY_GROUPS:{
            const groupData = formatGroupData(payload);
            return{
                ...state,
                ...groupData,
            }
        }
        case EXPENSE_POLICY_CONST.API_LOADING:{
            return {
                ...state,
                ...payload
            }
        }
        case EXPENSE_POLICY_CONST.UPDATE_DEFAULT_GROUP:{
            const {selectedGroupId,selectedGroupIndex} = payload
            return {
                ...state,
                selectedGroupId,
                selectedGroupIndex
            }
        }
        case EXPENSE_POLICY_CONST.POLICY_DATA:{
            const data = formatPolicyData(payload);
            const {policyData, lastUpdatedTime, lastUpdatedBy} = data;
            return {
                ...state,
                expensePolicyData : {
                    ...state.expensePolicyData,
                    ...policyData
                },
                lastUpdatedTime, 
                lastUpdatedBy
            }
        }
        case EXPENSE_POLICY_CONST.CLEAR_STATE:{
            return {...INITIAL_STATE};
        }
        default:
            return state;
    }
}
